<template>
  <div class="fill-height">
    <FufuHeader :shop="shop"> {{ firstVisitor ? '初回' : '' }}予約 </FufuHeader>
    <v-container class="white" fill-height>
      <v-layout column>
        <v-layout>
          <v-flex xs4>
            <v-btn
              v-if="menus.length === 0"
              :to="{
                name: 'ReservationTop',
                params: { shopId },
                query: {
                  first: firstVisitor,
                },
              }"
              text
              exact
              color="primary"
              replace
            >
              <v-icon>mdi-chevron-right</v-icon>
              前の画面へ戻る
            </v-btn>
            <v-btn v-else text color="primary" @click="menus = []">
              <v-icon>mdi-chevron-right</v-icon>
              前の画面へ戻る
            </v-btn>
          </v-flex>
          <v-flex xs4 class="text-center">
            <template v-if="menus.length > 0">
              カラー剤を選択してください
            </template>
            <template v-else>
              染める範囲を選択してください
            </template>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12>
            <v-card flat tile>
              <v-row v-if="menus.length > 0">
                <v-col v-for="menu in menus" :key="menu.id" cols="6">
                  <MenuCard
                    v-if="menu.color"
                    :price="getMenuPrice(menu)"
                    :name="menu.color.displayName"
                    :description="
                      menu.colorDescription || menu.color.description
                    "
                    @click="goNext(menu)"
                  />
                </v-col>
              </v-row>
              <MenuGroupSelection
                v-else
                :groups="groupedMenus"
                @menus="onSelectGroup"
              />
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { api } from '@/api'
import FufuHeader from '@/components/FufuHeader'
import MenuGroupSelection from '@/components/MenuGroupSelection'
import MenuCard from '@/components/MenuCard'

function fetchData(shopId) {
  return Promise.all([
    api.shops(shopId).get(),
    api.shops(shopId).getGroupedMenus(),
  ])
}

export default {
  name: 'MenuSelection',
  components: {
    FufuHeader,
    MenuCard,
    MenuGroupSelection,
  },
  props: {
    shopId: {
      type: String,
      required: true,
    },
    mode: {
      type: Number,
      default: 1,
    },
    firstVisitor: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    shop: null,
    menus: [],
    groupedMenus: [],
    next: null,
    selectedMenu: null,
    selectedOption: 0,
  }),
  computed: {
    specialPrice() {
      return this.mode === 2 && this.firstVisitor
    },
  },
  methods: {
    goNext(menu) {
      console.log('goNext', menu.id)
      this.$router.replace({
        name: 'TreatmentSelection',
        params: {
          shopId: this.shopId,
          menuId: menu.id,
        },
        query: {
          first: this.firstVisitor,
        },
      })
    },
    nl2br(text) {
      return text.replace(/\n/g, '<br />')
    },

    // getMenu(name) {
    //   return this.menus.find(x => x.name === name)
    // },
    getColorName(menu) {
      if (!menu || !menu.color) return
      return menu.color.displayName
    },
    getColorDescription(menu) {
      if (!menu || !menu.color) return
      return menu.color.description
    },
    getMenuPrice(menu) {
      if (this.specialPrice) {
        return Number(menu.firstPriceWithTax).toLocaleString()
      }
      const price = menu.priceWithTax || 0
      return Number(price).toLocaleString()
    },
    onSelectGroup(grp) {
      if (grp.menus.length === 1) {
        this.goNext(grp.menus[0])
      } else {
        this.menus = grp.menus
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    let shopId = to.params.shopId
    try {
      const [shop, menus] = await fetchData(shopId)
      next(vm => {
        vm.shop = shop
        vm.menus = []
        vm.groupedMenus = menus
      })
    } catch (err) {
      next(err)
    }
  },
  async beforeRouteUpdate(to, from, next) {
    let shopId = to.params.shopId
    try {
      const [shop, menus] = await fetchData(shopId)
      next(vm => {
        vm.shop = shop
        vm.menus = []
        vm.groupedMenus = menus
      })
    } catch (err) {
      next(err)
    }
  },
}
</script>
